import queryString from 'query-string';
import { getToken, removeToken } from './authStorage';

const { API_ENDPOINT } = process.env;

export const generateUrl = (url, params) => {
	const paramsString = queryString.stringify(params, { arrayFormat: 'bracket' });

	const URL =
		paramsString !== ''
			? `${API_ENDPOINT}/backstage/api/web/${url}?${paramsString}`
			: `${API_ENDPOINT}/backstage/api/web/${url}`;

	return URL;
};

export const wrapFetch = async (url, options = { headers: {} }, params = {}) => {
	const URL = generateUrl(url, params);

	const headers = new Headers({
		'Content-Type': 'application/json',
		Accept: 'application/json',
		...options.headers,
	});

	const result = await fetch(URL, { ...options, headers });

	return result.json();
};

export const wrapAuthFetch = async (url, options = { headers: {} }, params = {}) => {
	const token = getToken();

	if (token.accessToken === '') {
		throw new Error('Token not exist');
	}

	const { data, status, message } = await wrapFetch(
		url,
		{
			...options,
			headers: {
				Authorization: `Bearer ${token.accessToken}`,
				...options.headers,
			},
		},
		params,
	);

	if (status === 401 && message === 'Access token expired') {
		const win = window.open(`${API_ENDPOINT}/login?referral=EC`, '_blank');
		if (win) {
			win.focus();
		}
		removeToken();
		throw new Error('Access token expired');
	}

	return { data, status, message };
};
